<template>
AutomaticStamps  
</template>

<script>
export default {
    name: "AdjustFlextime",
    props: {
        employee_id: String,
    },
    setup(props) {
    }
}
</script>

<style>

</style>